import { Component } from '@angular/core';

interface Topic {
  icon: any;
  title: string;
  description: string;
}

@Component({
  selector: 'app-how-do-we-build',
  templateUrl: './how-do-we-build.component.html',
  styleUrl: './how-do-we-build.component.scss'
})
export class HowDoWeBuildComponent {

  topis : Topic[] = [
    {
      icon: 'target',
      title: 'Precisión y Compromiso',
      description: 'Construimos con la precisión de la ingeniería y el compromiso de una empresa familiar.'
    },
    {
      icon: 'leaf',
      title: 'Sostenibilidad',  
      description: 'Escuchamos, acompañamos y respondemos a nuestros clientes con atención personalizada, soluciones técnicas sólidas y resultados comprobables.'
    },
    {
      icon: 'shield-check',
      title: 'Calidad',
      description: 'Priorizamos la seguridad, la calidad y la transparencia, porque entendemos que lo más importante no es solo entregar una obra, sino mantener la confianza de quienes vuelven a elegirnos.'
    }
  ];

  trackElement(index: number, item: Topic): string {
    return `${item.title}-${index}`;
  }

}
